import { ENV } from "@/ENV";

export enum LicenseModule {
  TIMESTAMPCLOCK,
  BDE,
  SBBCUSTOMEVENTS,
  IOT,
}

// t("global.module.AUDIT")
// t("global.module.HLP")
// t("global.module.IDEA")
// t("global.module.MEET")
// t("global.module.REPORTING")
// t("global.module.TIMESTAMPCLOCK")
// t("global.module.LISACHART")
// t("global.module.IH")
// t("global.module.CHECKLIST")
// t("global.module.WORKFLOW")
// t("global.module.MQTT")
// t("global.module.INSTANCE")
// t("global.module.BDE")
// t("global.module.QUALITY")
// t("global.module.COMMON")
// t("global.module.SBBCUSTOMEVENTS")
// t("global.module.IOT")

export const moduleEnabled: Record<LicenseModule, boolean> = {
  [LicenseModule.TIMESTAMPCLOCK]: ENV?.VITE_APP_TIMESTAMPCLOCK_MODULE_ENABLED === "true",
  [LicenseModule.BDE]: ENV?.VITE_APP_BDE_MODULE_ENABLED === "true",
  [LicenseModule.SBBCUSTOMEVENTS]: ENV?.VITE_APP_SBBCUSTOMEVENTS_MODULE_ENABLED === "true",
  [LicenseModule.IOT]: ENV?.VITE_APP_IOT_MODULE_ENABLED === "true",
};

export function isModuleActive(module: LicenseModule | string) {
  let targetModule: LicenseModule;
  if (typeof module === "number") {
    targetModule = module;
  } else if (
    typeof module === "string" &&
    Object.values(LicenseModule).includes(module.toUpperCase()) === false
  ) {
    throw Error(`unknown license module requested: ${module}`);
  } else {
    // type of module is now string with a valid licenseModule string
    targetModule = LicenseModule[module.toUpperCase() as keyof typeof LicenseModule];
  }
  return moduleEnabled[targetModule];
}
